export default __webpack_public_path__ + "static/media/monkey-dark.1885760e.svg";